import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0a6e3a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contnet-warp" }
const _hoisted_2 = {
  class: "contnet-warp-round",
  id: "warp-round"
}
const _hoisted_3 = { class: "contnet-warp-round-icon" }
const _hoisted_4 = { class: "contnet-warp-round-text-r" }
const _hoisted_5 = {
  class: "inner",
  id: "text-r"
}
const _hoisted_6 = { class: "tip" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_9 = { class: "content-name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-color" }, null, -1))

import { baseSvg } from './svg-components/index';
import { ref, onMounted, computed } from 'vue';
import {
  selfAdaption,
  pcModulePatientSex7,
  useDataAssembly
  // sequence
} from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-7',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);

let dataArrCeil = computed(() => {
  return Math.floor(data.value.tipData.length / 2);
});

const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex7(TaskRef.value, dataArrCeil.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "contnet",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(baseSvg))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contnet-warp-round-item",
              id: "roundItems",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, null, 4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contnet-warp-round-arrow",
              id: "arrowItems",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, null, 4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contnet-warp-round-text",
              id: "textItems",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (citem, cindex) => {
                        return (_openBlock(), _createElementBlock("div", { key: cindex }, _toDisplayString(citem.label) + "：" + _toDisplayString(citem.value), 1))
                      }), 128))
                    ])
                  ]),
                  _hoisted_7,
                  _hoisted_8
                ])
              ])
            ], 4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "contnet-warp-round-line",
              id: "lines-sex-7",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, null, 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})